import { getBrazillianDateFormat } from 'packages/common/utils/format';

export function mountRegistrationWorkerBasicInfo(workerRegistration) {
  const basicInfo = [];

  basicInfo.push({
    label: 'Data de Nascimento',
    value: getBrazillianDateFormat(workerRegistration.dateOfBirth),
  },
  {
    label: 'Sexo',
    value: workerRegistration.gender.description,
  },
  {
    label: 'Estado Civil',
    value: workerRegistration.maritalStatus.description,
  },
  {
    label: 'Raça/Cor',
    value: workerRegistration.raceColor.description,
  },
  {
    label: 'Grau de Instrução',
    value: workerRegistration.educationLevel.description,
  },
  {
    label: 'Primeiro Emprego',
    value: workerRegistration.firstJob ? 'Sim' : 'Não',
  },
  {
    label: 'Telefone',
    value: workerRegistration.phone,
  },
  {
    label: 'Celular',
    value: workerRegistration.cellPhone,
  },
  {
    label: 'Nome da Mãe',
    value: workerRegistration.motherName,
  },
  {
    label: 'Nome do Pai',
    value: workerRegistration.fatherName,
  },
  {
    label: 'Aposentado',
    value: workerRegistration.retired ? 'Sim' : 'Não',
  },
  {
    label: 'Ficha Nº',
    value: workerRegistration.registrationNumber,
  },
  {
    label: 'Folha/Ficha',
    value: workerRegistration.sheetNumber,
  });

  if (!workerRegistration?.foreigner) {
    basicInfo.push(
      {
        label: 'UF de Nascimento',
        value: workerRegistration.ufBirth.name,
      },
      {
        label: 'Código Município de Nascimento',
        value: workerRegistration.birthCityCode,
      }
    );
  }

  return basicInfo;
}

export function mountRegistrationWorkerAddress(workerRegistration) {
  const address = [];

  if (workerRegistration.residenceAbroad) {
    address.push({
      label: 'Residente no Exterior',
      value: 'Sim',
    }, {
      label: 'Código Postal',
      value: workerRegistration.foreignResidencePostalCode,
    }, {
      label: 'Código do País',
      value: `${workerRegistration.foreignCountryResidence?.code} - ${workerRegistration.foreignCountryResidence?.countryName}`,
    });
  }

  address.push(
    {
      label: 'Logradouro',
      value: workerRegistration.street,
    },
    {
      label: 'Número',
      value: workerRegistration.number,
    },
    {
      label: 'Complemento',
      value: workerRegistration.complement,
    },
    {
      label: 'Bairro',
      value: workerRegistration.neighborhood,
    },
    {
      label: 'Cidade',
      value: workerRegistration.city,
    },
  );

  if (!workerRegistration.residenceAbroad) {
    address.push({
      label: 'Estado',
      value: workerRegistration.uf.name,
    }, {
      label: 'CEP',
      value: workerRegistration.zipCode,
    });
  }

  return address;
}

export async function mountWorkerNationality(workerRegistration) {
  return [
    {
      label: 'Cidadão Estrangeiro',
      value: workerRegistration.foreigner ? 'Sim' : 'Não',
    },
    {
      label: 'Data de Chegada',
      value: getBrazillianDateFormat(workerRegistration.foreignerArrivalDate),
    },
    {
      label: 'Tempo de Residência',
      value: workerRegistration.residenceTime.description,
    },
    {
      label: 'Condição do Funcionário',
      value: `${workerRegistration.foreignWorkerClass.description} (${workerRegistration.foreignWorkerClass.name})`,
    },
    {
      label: 'Casado com brasileiro(a)',
      value: workerRegistration.foreignerMarriedWithBrazilian ? 'Sim' : 'Não',
    },
    {
      label: 'Tem filhos brasileiros',
      value: workerRegistration.foreignerHasBrazilianChildren ? 'Sim' : 'Não',
    },
    {
      label: 'Número do RNE',
      value: workerRegistration.foreignerRne,
    },
    {
      label: 'Órgão Emissor e UF do RNE',
      value: workerRegistration.rneIssuingBody,
    },
    {
      label: 'Código do país de nascimento',
      value: `${workerRegistration.birthCountry?.code} - ${workerRegistration.birthCountry?.countryName}`,
    },
    {
      label: 'Código do país de nacionalidade',
      value: `${workerRegistration.country?.code} - ${workerRegistration.country?.countryName}`,
    },
  ];
}

export function mountRegistrationWorkerDocuments(workerRegistration) {
  return [
    {
      label: 'CPF',
      value: workerRegistration.cpf,
    },
    {
      label: 'NIS',
      value: workerRegistration.nis,
    },
    {
      label: 'CTPS digital',
      value: workerRegistration.digitalWallet ? 'Sim' : 'Não',
    },
    {
      label: 'Número da CTPS',
      value: workerRegistration.ctps,
    },
    {
      label: 'Série da CTPS',
      value: workerRegistration.ctpsSeries,
    },
    {
      label: 'UF da CTPS',
      value: workerRegistration.ufCtps ? workerRegistration.ufCtps.name : '',
    },
    {
      label: 'Número do RG',
      value: workerRegistration.rg,
    },
    {
      label: 'Órgão Emissor do RG',
      value: workerRegistration.rgIssuingBody,
    },
    {
      label: 'Data de Expedição do RG',
      value: getBrazillianDateFormat(workerRegistration.rgCreationDate),
    },
    {
      label: 'Número da CNH',
      value: workerRegistration.cnh,
    },
    {
      label: 'UF da CNH',
      value: workerRegistration.ufCnh ? workerRegistration.ufCnh.name : '',
    },
    {
      label: 'Data de Validade da CNH',
      value: getBrazillianDateFormat(workerRegistration.cnhDueDate),
    },
    {
      label: 'Categoria da CNH',
      value: workerRegistration.cnhCategory,
    },
    {
      label: 'Título de Eleitor',
      value: workerRegistration.voterRegistration,
    },
    {
      label: 'Certificado Reservista',
      value: workerRegistration.reservistCertificate,
    },
  ];
}

export function mountRegistrationWorkerHandicappedInfo(workerRegistration) {
  if (!workerRegistration.disability) {
    return [{
      label: 'Portador de Deficiência',
      value: 'Não',
    }];
  }

  return [
    {
      label: 'Deficiência Física',
      value: workerRegistration.physicalDisability ? 'Sim' : 'Não',
    },
    {
      label: 'Deficiência Visual',
      value: workerRegistration.visualImpairment ? 'Sim' : 'Não',
    },
    {
      label: 'Deficiência Auditiva',
      value: workerRegistration.hearingDeficiency ? 'Sim' : 'Não',
    },
    {
      label: 'Deficiência Mental',
      value: workerRegistration.mentalDisability ? 'Sim' : 'Não',
    },
    {
      label: 'Deficiência Intelectual',
      value: workerRegistration.intellectualDisability ? 'Sim' : 'Não',
    },
    {
      label: 'Preenche Cota de Pessoas com Deficiência',
      value: workerRegistration.peopleWithDisabilitiesQuote ? 'Sim' : 'Não',
    },
  ];
}

export function mountRegistrationWorkerAdditionalInfo(workerRegistration) {
  const additionalData = [
    {
      label: 'Adiantamento do 13º',
      value: workerRegistration.thirteenthVacation ? 'Sim' : 'Não',
    }, {
      label: 'Calcular anuênio',
      value: workerRegistration.annual ? 'Sim' : 'Não',
    },
  ];

  if (workerRegistration.annual) {
    additionalData.push(...[
      {
        label: 'Percentual de Incremento do Anuênio',
        value: `${workerRegistration.annualPercentage || 0}%`,
      }, {
        label: 'Limite de Anos do Anuênio',
        value: workerRegistration.annualLimit || 0,
      },
    ]);
  }

  if (workerRegistration.alimonyDependentName || workerRegistration.alimonyDependentCpf) {
    additionalData.push(...[
      {
        label: 'Dependente de Pensão Alimentícia ',
        value: workerRegistration.alimonyDependentName,
      }, {
        label: 'Dependente de Pensão Alimentícia (CPF) ',
        value: workerRegistration.alimonyDependentCpf,
      },
    ]);
  }

  return additionalData;
}
